import Navbar from "../../components/Navbar/Navbar";
import Table from "../../components/TableConstructor";
import Cabecalho from "../../components/Cabecalho";
import styles from "./styles.module.css";
import { useContext, useEffect, useState } from "react";
import RowColaboracao from "../../components/TableConstructor/Row/RowColaboracoes";
import getEditais from '../../services/getEditais';
import { UserContext } from "../../context/UserContext";
import Modal from "react-responsive-modal";
import AddColaboracao from "../../components/ModalForms/AddColaboracao";


type Edital = {
  id: number;
  titulo: string;
  descricao: string;
  link: string;
  inicio: Date;
  fim: Date;
}

function Colaboracoes() {
  const [listaEditais, setListaEditais] = useState<Edital[]>([]);
  const [openNewColaboracao, setNewColaboracao] = useState(false);
  const { token } = useContext(UserContext);

  useEffect(() => {
    const carregarDadosEditais = async () => {
      try {
        const editais = await getEditais(token);
        const listaDeEditais: Edital[] = [];
        for (let i = 0; i < editais.length; i++) {
          listaDeEditais.push({
            id: editais[i].id,
            titulo: editais[i].titulo,
            descricao: editais[i].descricao,
            link: editais[i].link_pdf,
            inicio: editais[i].data_lancamento,
            fim: editais[i].data_encerramento,
          });
        }
        setListaEditais(listaDeEditais);
      } catch (error) {
        console.error("Dados editais:", error);
      }
    }
    carregarDadosEditais();
  }, []);




  
  const addEdital = (edital: Edital) => {
    setListaEditais([edital, ...listaEditais]);
  };
  const closeModal = () => setNewColaboracao(false);

  return (
    <div className={styles.page}>
      <Navbar activeIndex={2} />
      <section>
        <Cabecalho title="Editais de Colaboração" icon="document" />
        <main>
          <div className={styles.container}>
            <h3>Editais criados</h3>
            <div className={styles.container_data}>
              <Table
                listTitle={["Titulo", "Descrição", "Duração", ""]}
                styleList={[0, 0, 1]}
              >
                 {listaEditais.length > 0 &&
                  listaEditais.map((edital, index) => (
                <RowColaboracao
                   titulo={edital.titulo}
                   descricao={edital.descricao}
                   inicio={edital.inicio}
                   fim={edital.fim}
                   id={edital.id}
                   link={edital.link}
                   key={index}
                />
                  ))}
              </Table>

              <button
                className={styles.addBtn}
                onClick={() => setNewColaboracao(true)}
              >
                + Edital de Colaboração
              </button>
              <Modal
              open={openNewColaboracao}
              onClose={() => setNewColaboracao(false)}
              center
              classNames={{
                modal: styles.customModal,
              }}
            >
              <AddColaboracao
                closeModal={ () => setNewColaboracao(false) }
                atualizaListaEditais={addEdital}
              />
            </Modal>
            </div>
          </div>
        </main>
      </section>
    </div>
  );
}

export default Colaboracoes;